export default {
    state: {
        isWorld: true,
        isLoadingStarted: false
    },
    actions: {},
    mutations: {
        setWorld(state, content) {
            state.isWorld = content;
        },
        setIsLoadingStarted(state, content) {
            state.isLoadingStarted = content;
        }
    },
    getters: {
        getWorld(state) {
            return state.isWorld;
        },
        getIsLoadingStarted(state) {
            return state.isLoadingStarted;
        }
    }
};
